import '../app.ts'
import '/@front:css/views/account.login.css'

import { useForm } from 'laravel-precognition-vue'
import { computed, onMounted } from 'vue'

import { mountPage } from '/@front:shared/mount-page'
import { scrollErrorIntoView } from '/@front:shared/utils'

mountPage({
  name: 'account-login',
  setup() {
    const form = useForm('post', location.pathname, {
      email: '',
      password: '',
    })

    const canSubmitLogin = computed(() => {
      if (!form.email || !form.email.length || !form.email.includes('@')) {
        return false
      }

      if (!form.password || form.password.length < 5) {
        return false
      }

      return true
    })

    onMounted(() => {
      try {
        const email = localStorage.getItem('auth:login:email')
        if (email) {
          form.email = email
        }
      } catch (_e) {
        // ignore
      }
    })

    const submitLogin = () => {
      form
        .submit()
        .then((response: any) => {
          const data = response.data

          location.assign(data.url ?? '/')
        })
        .catch(() => scrollErrorIntoView())
    }

    const rememberEmail = (event: KeyboardEvent) => {
      const target = event.target as HTMLInputElement
      const email = target.value

      if (email.length < 5) {
        return
      }

      try {
        localStorage.setItem('auth:login:email', email)
      } catch (_e) {
        // ignore
      }
    }

    return {
      rememberEmail,
      form,
      canSubmitLogin,
      submitLogin,
    }
  },
})
